<template>
	<div class="container">
		<scroll-view scroll-y class="content" v-html="content"></scroll-view>
		<div class="button" @click="toapply">确认了解</div>
	</div>
</template>

<script>
	export default {
		name: 'Index',
		data() {
			return {
				content: '12345'
			}
		},
		methods: {
			toapply() {
				uni.navigateTo({
					url: '/pages/answer/answer'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		height: 100vh;
		padding: 30rpx;
		box-sizing: border-box;
		display: flex;
		flex-flow: column;

		.content {
			flex: 1;
			height: calc(100% - 88rpx - 60rpx - 40rpx);
		}

		.button {
			margin-top: 40rpx;
			width: 100%;
			height: 88rpx;
			line-height: 88rpx;
			text-align: center;
			background: #025EEF;
			border-radius: 44rpx;
			font-size: 32rpx;
			font-weight: 500;
			color: #FFFFFF;
		}
	}
</style>